module.exports = __webpack_public_path__ + "static/media/logo_coris.5825351c.png";